import  {baseActions}  from "./base.actions";

export const certificationReferenceActions = {
    add,
    gets,
    get,
    
};

function add(obj,func) {
    
    return baseActions.add(obj,'certificationreference',null,func)
}

function gets() {
    return baseActions.getall('certificationreference');
}

function get(id)
{
    return baseActions.get('certificationreference',id);
}
